<template>
  <div class="room" @click="parent_toggle_collapse(room.id)">
    <vb-card
      variant="horizontal"
      :card="card_room"
      @click_image="open_modal_room(room.id)"
    >
      <div class="room__wrap">
        <room-info :room="room" />
        <div :class="'room__toggle ' + (!collapsed ? 'room__toggle--not-collapsed' : '')">
          <span class="room__toggle-price" v-if="price > 0">da € {{ price }}</span>
          <div class="room__toggle-btn">
            <span class="room__toggle-text">dettagli</span>
            <vb-icon class="room__toggle-icon" :name="'angle_small_down'" :color="sass('info')" :size="18" />
          </div>
        </div>
      </div>

      <vb-icon
        class="room__dotted"
        :name="'dotted'"
        :color="sass('dark')"
        :size="25"
        @click="open_modal_room(room.id)"
        @click.stop
      />
    </vb-card>

    <vb-modal
      :vb_options="{
        id: 'modal_room_' + room.id,
        body_class: 'room__modal',
        title: room.name,
        size: 'lg',
        centered: true,
        hide_footer: true
      }"
    >
      <room-modal :room="room" />
    </vb-modal>
  </div>
</template>

<script>
import { smaller } from "mathjs"
import RoomInfo from '@liveeps/components/blocks/detail/room/room-info'
import RoomModal from '@liveeps/components/blocks/detail/room/room-modal'

export default {
  name: 'room',

  components: {
    'room-info': RoomInfo,
    'room-modal': RoomModal,
  },

  props: {
    room: Object
  },

  data() {
    return {
      collapsed: true // stato del collapse, attualmente utlizzato dall'icona arrow
    }
  },

  computed: {

    // Ritorna struttura dati per il componente vb-card => :card
    card_room(){
      return {
        image: this.room.images ? this.room.images.find(item => item.hero_image)['1000px'] : '/assets/images/common/statics/room_placeholder.png',
        title: this.room.name ? this.room.name : undefined,
        text: this.room.descriptions ? this.room.descriptions.overview.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, ' - ').replace(/<br\s*\/?>/g, '') : undefined,
      }
    },

    // Ritorna il prezzo più basso tra rates
    price(){
      return this.room.rates.reduce((min_tot_amount, rate) => {
        const tot_amount = rate.pricing.total
        return min_tot_amount === 0 || smaller(tot_amount, min_tot_amount) ? tot_amount : min_tot_amount
      }, 0)
    }

  },

  created() {
  },

  mounted() {
  },

  update() {
  },

  methods: {

    // Emette il toggle per aprire/chiudere il collapse della camera (data:collapsed)
    parent_toggle_collapse(payload) {
      this.$emit('toggle-collapse', payload)
      this.collapsed = !this.collapsed
    },

    // Apre la modale delle info room
    open_modal_room(id) {
      this.$bvModal.show('modal_room_' + id)
    }

  },
}
</script>

<style lang="scss" scoped>

  .room {
    cursor: pointer;

    &__wrap {
      display: flex;
      align-items: center;
      justify-content: right;
      margin-top: $grid-gutter-width / 3;

      @include media-breakpoint-up(md){
        margin-top: $grid-gutter-width;
        justify-content: space-between;
      }
    }

    &__toggle {
      $this: &;
      display: flex;
      align-items: center;
      cursor: pointer;

      &-price {
        font-size: $font-size-md;
        font-weight: $vb-font-weight-semibold;
        color: var(--primary);
        margin-right: $grid-gutter-width / 3;
        display: none;

        @include media-breakpoint-up(lg){
          display: block;
        }
      }

      &-btn {
        display: flex;
        align-items: center;
        margin-top: -2px;
      }

      &-text {
        color: var(--info);
        text-decoration: underline;
      }

      &-icon {
        position: relative;
        top: 3px;

        @at-root #{$this}--not-collapsed & {
          transform: rotate(-180deg);
        }
      }
    }

    &__dotted {
      position: absolute;
      top: $grid-gutter-width / 3;
      right: $grid-gutter-width;
      cursor: pointer;
      display: none;

      @include media-breakpoint-up(lg){
        display: block;
      }
    }

    ::v-deep {

      .vb-card {

        &__title {
          font-size: $font-size-xl;

          &:before {
            content: '';
            display: inline-block;
            width: 5px;
            height: 15px;
            background: $secondary;
            border-radius: $border-radius;
            margin-right: $grid-gutter-width / 3;
          }
        }

        &__text {
          font-size: $font-size-md;
          height: 65px;
          overflow: hidden;
          border-top: 0;
          margin-top: $grid-gutter-width / 3;
        }
      }

      strong, b {
        font-weight: $vb-font-weight-semibold;
      }
    }
  }

</style>